export default __webpack_public_path__ + "static/media/bag4.9ec64eaa.png";